import React from "react";
import PropTypes from "prop-types";
import { Col } from "jsxstyle";
import { Spinner } from "@blueprintjs/core";
import CMBSRatingsForm from "./CMBSRatingsForm";
import useAsync from "hooks/useAsync";
import Modal from "components/Modal";
import loadCMBSRatingsService from "services/cmbs/loadCMBSRatingsService";
import loadCMBSTranchePriceRatingsService from "services/cmbs/loadCMBSTranchePriceRatingsService";

function CMBSRatingsFormModal({ trancheId, onData, onRequestClose, dealCode }) {
  const [
    fetchRatingAgencies,
    pendingRatingAgencies,
    dataRatingAgencies,
  ] = useAsync({
    promiseFn: loadCMBSRatingsService,
  });

  const [fetchTranches, pendingTranches, dataTranches] = useAsync({
    promiseFn: loadCMBSTranchePriceRatingsService,
  });

  React.useEffect(() => {
    if (dealCode && trancheId) {
      fetchRatingAgencies({ dealCode: dealCode });
      fetchTranches({ dealCode: dealCode, trancheId: trancheId });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealCode, trancheId]);

  return (
    <Modal visible={trancheId} onRequestClose={onRequestClose}>
      {pendingRatingAgencies || pendingTranches ? (
        <Col
          width={600}
          minHeight={482}
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </Col>
      ) : (
        <CMBSRatingsForm
          ratingAgencies={dataRatingAgencies || []}
          tranches={dataTranches || []}
          dealCode={dealCode}
          trancheId={trancheId}
          onRequestClose={onRequestClose}
          onData={onData}
        />
      )}
    </Modal>
  );
}

CMBSRatingsFormModal.propTypes = {
  trancheId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dealCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onData: PropTypes.func,
  onRequestClose: PropTypes.func,
};

CMBSRatingsFormModal.defaultProps = {
  onData: () => {},
  onRequestClose: () => {},
  trancheId: null,
};

export default CMBSRatingsFormModal;
